import MenuListDetails from './MenuListDetails';
import NotInformation from '../../../../../components/NotInformation';
import CustomExpandableTable from './../../../../../components/table/CustomExpandableTable';
import routes from '../../../../../Routes/routes';
import { permissionObj } from '../../../../../Helpers/permission';
import { useSelector } from 'react-redux';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const MenuAccordion = ({
    t,
    DEV,
    columns,
    searchResults,
    handleCheckboxChange,
    handleCheckedAll,
    selectedList,
    renderOptionsMenu,
    searchElement,
    deletePermission
}) => {
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const rows = searchResults?.content || [];
    const handleRowExpand = (row) => {};
    const RenderExpandedRow = ({ row }) => <MenuListDetails id={row.id} DEV={DEV} row={row} />;

    return (
        <>
            {/**Done*/}
            {rows.length > 0 ? (
                <CustomExpandableTable
                    columns={columns}
                    rows={rows}
                    renderExpandedRow={RenderExpandedRow}
                    renderOptionsMenu={renderOptionsMenu}
                    onRowExpand={handleRowExpand}
                    selectedList={selectedList}
                    handleCheckboxChange={handleCheckboxChange}
                    handleDeleteAll={handleCheckedAll}
                    checkbox={deletePermission}
                />
            ) : (
                <NotInformation
                    className={"mt-4"}
                    card={true}
                    text={ t('no_menu_text')}
                    showButton={((DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_CREATE)))}
                    buttonId={'btn_ma_link_create_menu'}
                    buttonUrl={routes.foodieMenu.create}
                    buttonTrans={'add_new_menu'}
                    searchElement={searchElement}
                />
            )}
        </>
    );
};

export default MenuAccordion;
